import React from 'react'

import Sidebar from '../../../Sidebar/Sidebar'

import s from './Sections.scss'


const FiltersOverlay = () => (
  <div className={s.section}>
    <div className={s.content}>
      <Sidebar fullWidth />
    </div>
  </div>
)

export default FiltersOverlay
